module.exports = __webpack_public_path__ + "static/media/BASIS-WATERNIVEAU_04.49b7dd8d.apng";